export const removeAfterPoint=(str:string)=>{
  
    return str.includes(".")?str.split('.')[0]+"."+str.split('.')[1].substring(0,2):str+".00";
}

